module.exports = __webpack_public_path__ + "images/eurocross_smalla69b831865943feb20aa9e7d4c737573.png";